import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useState } from 'react';
import { Stack, Typography, useSnackbar } from '@emburse/embark-core';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import BankAccountInfo from '../BankAccountInfo';
import BusinessInformationForm from '../BusinessInformationForm';
import OwnerAccountControllerInfoForm from '../OwnerAccountControllerInfoForm';
import MerchantServiceAgreement from '../MerchantServiceAgreement';
import { useDialog } from '../../../components/Dialog';
import { submitForteApplication } from '../../../api/forteApplication';
import { ForteApplicationContext } from '../../../views/ForteApplication/Common/ForteApplicationProvider';
import CompletedView from '../../../views/ForteApplication/CompletedView';
import useLoadingOverlay from '../../../hooks/useLoadingOverlay';
function ApplicationStepperView() {
    const [activeStep, setActiveStep] = useState(null);
    const { enqueueDialog, toggleConfirmEnabled } = useDialog();
    const { enqueueSnackbar } = useSnackbar();
    const { applyLoadingState, removeLoadingState } = useLoadingOverlay();
    const [showMerchantServiceAgreement, setShowMerchantServiceAgreement] = useState(false);
    const { getApplicationStatus, applicationStatus, parseCurrentStepFromApplication, loading } = useContext(ForteApplicationContext);
    const steps = [
        'Business Information',
        'Bank Account Information',
        'Owner/Account Controller Information',
        'Complete'
    ];
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const MerchantServiceAgreementDialog = {
        title: 'Merchant Service Agreement',
        show: showMerchantServiceAgreement,
        showClose: true,
        size: 'md',
        onClose: () => setShowMerchantServiceAgreement(false),
        onConfirm: async () => {
            try {
                applyLoadingState();
                await submitForteApplication();
                handleNext();
                enqueueSnackbar('ACH reimbursement application submitted successfully', {
                    variant: 'success'
                });
            }
            catch (e) {
                enqueueSnackbar(e.message, {
                    variant: 'error',
                    style: {
                        whiteSpace: 'pre-line'
                    }
                });
            }
            finally {
                removeLoadingState();
                setShowMerchantServiceAgreement(false);
            }
        },
        disableConfirm: true,
        content: _jsx(MerchantServiceAgreement, { onCheckboxToggled: toggleConfirmEnabled })
    };
    const handleMerchantServiceAgreement = () => {
        enqueueDialog(MerchantServiceAgreementDialog);
    };
    useEffect(() => {
        (async () => {
            if (activeStep === 3) {
                await getApplicationStatus();
            }
        })();
    }, [activeStep, getApplicationStatus]);
    useEffect(() => {
        if (!loading && activeStep === null) {
            const loadedCurrentStep = parseCurrentStepFromApplication();
            setActiveStep(loadedCurrentStep);
        }
    }, [loading, activeStep, parseCurrentStepFromApplication]);
    return (_jsxs(Stack, { sx: { width: '100%' }, alignItems: "flex-start", spacing: 6, children: [_jsx(Stack, { direction: "row", sx: { width: '100%' }, spacing: 3, children: _jsx(Typography, { variant: "h4", children: "ACH Reimbursement Application" }) }), _jsxs(Stack, { direction: "row", sx: { width: '100%' }, spacing: 4, alignItems: "flex-start", children: [_jsx(Stepper, { activeStep: activeStep, orientation: "vertical", sx: { flexGrow: 1 }, children: steps.map((label) => (_jsx(Step, { children: _jsx(StepLabel, { children: label }) }, label))) }), _jsx(Stack, { alignItems: "flex-start", sx: { width: '100%' }, children: _jsxs(Stack, { sx: { width: '100%' }, alignItems: "flex-start", children: [!activeStep && _jsx(BusinessInformationForm, { afterFormSave: handleNext }), activeStep === 1 && (_jsx(BankAccountInfo, { afterFormSave: handleNext, backButtonCallback: handleBack })), activeStep === 2 && (_jsx(OwnerAccountControllerInfoForm, { afterFormSave: handleMerchantServiceAgreement, backButtonCallback: handleBack })), activeStep === 3 && _jsx(CompletedView, { status: applicationStatus?.Status })] }) })] })] }));
}
export default ApplicationStepperView;
